import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {LexicalEditor} from 'lexical/LexicalEditor';

import {RefObject, useEffect} from 'react';

export function EditorRefPlugin({editorRef}: {editorRef: RefObject<LexicalEditor | null>}) {
  const [editor] = useLexicalComposerContext();

  useEffect(
    function syncEditorRef() {
      editorRef.current = editor;
    },
    [editor, editorRef]
  );

  return null;
}
